import React from "react";
import TrackVisibility from "react-on-screen";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Yuri Baptista",
  avatarImage: "/images/png.png",
  content:
    "Maquilladora Profesional Cruelty-free",
};

const progressData = [
  {
    id: 1,
    title: "Maquillaje social",
    percantage: 90,
    progressColor: "#D69DAE",
  },
  {
    id: 2,
    title: "Maquillaje Editorial",
    percantage: 70,
    progressColor: "#D69DAE",
  },
  {
    id: 3,
    title: "Manicure",
    percantage: 65,
    progressColor: "#D69DAE",
  },

  {
    id: 4,
    title: "Estética (cejas y pestañas)",
    percantage: 70,
    progressColor: "#D69DAE",
  },


];



function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="Yurita MakeUp" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    <a href="https://www.behance.net/gallery/110881661/Yurita-Makeup" target="_blank rel-nonopener" className="btn btn-default">
                      Portafolio
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>

                
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
    
      </div>

    </section>


  );
}

export default About;
